// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tippy-box[data-theme~=none]{--tw-shadow:0 0 transparent;--tw-shadow-colored:0 0 transparent;background-color:transparent;border-radius:0;box-shadow:0 0 transparent,0 0 transparent,0 0 transparent;box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
